import styled from "styled-components";


export const StyledLanguageToggle = styled.div`
  position: fixed;
  top: 1rem;
  left: 1rem;

  label {
    margin-bottom: 0;
  }
`;
